// extracted by mini-css-extract-plugin
export default {"advertTabs":"tpNolwxw"};